"use client";
import { useTranslations } from "next-intl";
import Reveal from "../../components/Reveal";
import { motion } from "framer-motion";

export default function Goal() {
  const t = useTranslations("invester");
  const data = [
    {
      content: t("high-growth-seekers"),
      describe: t(
        "capture-outsized-returns-from-the-15-7t-ai-driven-economy-by-2030",
      ),
    },
    {
      content: t("impact-investors"),
      describe: t(
        "support-the-redistribution-of-digital-power-building-a-fairer-and-more-inclusive-ai-future",
      ),
    },
    {
      content: t("strategic-alliances"),
      describe: t(
        "for-governments-enterprises-and-funds-seeking-sovereignty-compliance-and-infrastructure-leadership",
      ),
    },
    {
      content: t("early-stage-pioneers"),
      describe: t(
        "join-a-project-with-a-clear-10-year-roadmap-toward-ipo-and-layer-1-sovereignty",
      ),
    },
  ];

  return (
    <section className="relative overflow-hidden py-20">
      <div className="absolute -top-[191px] left-1/2 -z-10 h-[600px] max-h-[600px] w-[150vw] -translate-x-1/2 overflow-hidden rounded-none bg-[#e3e3e6] opacity-50 sm:w-[140vw] lg:w-[110vw] xl:w-[100vw]">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="block h-full w-full object-cover object-center"
        >
          <source
            src="https://cdn-r2.hyra.network/hyra-network/Shape.webm"
            type="video/webm"
          />
        </video>
      </div>
      <div className="absolute top-0 -z-10 h-[410px] w-full bg-gradient-to-b from-transparent to-white" />
      <div className="flex flex-col items-center justify-center max-lg:px-10 max-lg:text-center max-sm:px-4">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h2 className="max-w-[560px] text-center text-[48px]/[56px] tracking-[-1px] text-[#202020] max-lg:text-[32px]/[40px]">
            {t("which")} <span className="text-[#06f]">{t("goal")}</span>{" "}
            {t("can-you-check-off-your-list")}
          </h2>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mb-[56px] mt-6 text-base font-light text-[#646464]">
            {t(
              "investors-come-with-different-goals-and-hyra-network-offers-a-unique-opportunity-that-fits-diverse-strategies",
            )}
          </p>
        </Reveal>
      </div>

      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="max-lg:px-10 max-sm:px-4"
      >
        <div className="flex flex-col items-center justify-center gap-[14px]">
          {data.map((item, index) => (
            <div
              key={index}
              className="w-full max-w-[844px] rounded-[24px] border-[2px] border-[#E9F3FF] bg-[#F3F8FF] p-6"
            >
              <p className="text-[20px] tracking-[-0.5px] text-[#202020]">
                {item.content}
              </p>
              <p className="mt-3 text-base font-light text-[#646464]">
                {item.describe}
              </p>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
